<ng-container *ngIf="config$ | async as config">
  <ul class="app-search-list" *ngIf="pages$ | async as pages">
    <li *ngIf="pages.length === 0" [hidden]="config.dataLoading">No XML to show</li>
    <ng-container *ngIf="pages.length > 0">
      <li
        *ngFor="let result of pages; let index = index"
        [style.marginTop]="searchVal && 0"
        [style.marginBottom]="searchVal && 0"
      >
        <div *ngIf="!searchVal" (click)="toogleVisibility(index)">
          <h6>{{ result['@attributes']['ident'] }}</h6>
          <h4>{{ result.displayName }}</h4>
          <app-icon class="dark" name="caret-down-fill"></app-icon>
        </div>

        <div *ngIf="result.visible || searchVal" class="app-search-list-inner">
          <div
            class="app-search-list-inner-info"
            *ngFor="let page of result.page | arrayFilter : searchVal"
            ngcla
            [ngClass]="{
              active: page['@attributes']['numpage'] == config.currentPageNumber
            }"
            (click)="changePageNumber(page['@attributes']['numpage'])"
          >
            <h5>
              {{ page.displayName }}
            </h5>
            <p>
              {{ page['@attributes']['ident'] }}
            </p>
          </div>
        </div>
      </li>
    </ng-container>
  </ul>
</ng-container>
